function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import file from '@/utils/file';
import Vue from 'vue';
Vue.use(file);
import { billCateApi, billImportApi, enterprisePayTypeApi } from '@/api/enterprise';
export default {
  name: 'FormBox',
  props: ['total'],
  components: {
    importExcel: function importExcel() {
      return import('@/components/common/importExcel');
    },
    exportExcel: function exportExcel() {
      return import('@/components/common/exportExcel');
    },
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    }
  },
  data: function data() {
    return {
      timeVal: [this.$moment().startOf('months').format('YYYY/MM/DD'), this.$moment().endOf('months').format('YYYY/MM/DD')],
      gettime: '',
      tableFrom: {
        name: '',
        time: '',
        types: '',
        type_id: '',
        search: 0,
        cate_id: [],
        exportType: 0
      },
      payData: [],
      exportFileUrl: '',
      sexOptions: [{
        label: this.$t('finance.all'),
        value: ''
      }, {
        label: this.$t('finance.income'),
        value: '1'
      }, {
        label: this.$t('finance.pay'),
        value: '0'
      }],
      statusOptions: [{
        label: this.$t('toptable.all'),
        value: ''
      }],
      saveName: '',
      exportData: {
        data: [],
        cols: [{
          wpx: 70
        }, {
          wpx: 70
        }, {
          wpx: 120
        }, {
          wpx: 140
        }, {
          wpx: 120
        }]
      },
      columnNumber: 2,
      dropdownList: [{
        label: '导出',
        value: 1
      }, {
        label: '导入',
        value: 2
      }, {
        label: '下载模板',
        value: 3
      }],
      search: [{
        field_name: '金额/备注',
        field_name_en: 'name',
        form_value: 'input'
      }, {
        field_name: '开始时间',
        field_name_end: '结束时间',
        field_name_en: 'time',
        form_value: 'date_picker',
        data_dict: [this.$moment().startOf('months').format('YYYY/MM/DD'), this.$moment().endOf('months').format('YYYY/MM/DD')]
      }, {
        field_name: '账目分类',
        field_name_en: 'cate_id',
        form_value: 'cascader',
        data_dict: [],
        props: {
          collapseTags: true
        }
      }, {
        field_name: '支付方式',
        field_name_en: 'type_id',
        form_value: 'select',
        data_dict: []
      }],
      treeData: [{
        options: [{
          value: '',
          label: '全部'
        }, {
          value: '1',
          label: '收入'
        }, {
          value: '0',
          label: '支出'
        }]
      }]
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  created: function created() {
    this.tableFrom.time = "".concat(this.timeVal[0], "-").concat(this.timeVal[1]);
    this.getBillCate();
    this.getPayType();
  },
  methods: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    dropdownFn: function dropdownFn(data) {
      switch (data.value) {
        case 1:
          this.getExportData();
          break;
        case 2:
          this.$refs.importExcel.$el.querySelector('input').click();
          break;
        case 3:
          this.exportTemplate();
          break;
      }
    },
    setOptions: function setOptions() {
      this.sexOptions = [{
        label: this.$t('finance.all'),
        value: ''
      }, {
        label: this.$t('finance.income'),
        value: '0'
      }, {
        label: this.$t('finance.pay'),
        value: '1'
      }];
      this.statusOptions = [{
        label: this.$t('toptable.all'),
        value: ''
      }];
    },
    addFinance: function addFinance() {
      this.$emit('addFinance');
    },
    exportTemplate: function exportTemplate() {
      this.$emit('exportTemplate');
    },
    getExportData: function getExportData() {
      this.$emit('getExportData');
    },
    // 获取收入类型
    getBillCate: function getBillCate(type) {
      var _this = this;
      var data = {
        types: type
      };
      var list = [{
        label: this.$t('toptable.all'),
        value: ''
      }];
      billCateApi(data).then(function (res) {
        res.data === undefined ? res.data = [] : res.data;
        _this.statusOptions = res.data;
        _this.setDataDict('cate_id', res.data);
      });
      return list;
    },
    getPayType: function getPayType() {
      var _this2 = this;
      var data = {
        page: 1,
        limit: 0
      };
      enterprisePayTypeApi(data).then(function (res) {
        var data = res.data.list ? res.data.list : [];
        _this2.exportFileUrl = res.data.import_temp;
        _this2.payData = data;
        _this2.payData.unshift({
          name: _this2.$t('toptable.all'),
          id: ''
        });
        _this2.setDataDict('type_id', _this2.payData);
      });
    },
    // 确认
    handleConfirm: function handleConfirm() {
      this.tableFrom.exportType = 0;
      this.tableFrom.search = 1;
      this.confirmData();
    },
    // 搜索记账类型
    handType: function handType(e) {
      this.tableFrom.types = e;
      this.handleConfirm();
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.search[1].data_dict = this.timeVal;
        this.tableFrom = {
          name: '',
          time: '',
          types: '',
          type_id: '',
          search: 0,
          cate_id: [],
          exportType: 0
        };
      } else {
        this.tableFrom = _objectSpread(_objectSpread({}, this.tableFrom), data);
        this.tableFrom.cate_id = this.unique(this.tableFrom.cate_id);
      }
      this.tableFrom.search = 1;
      this.$emit('confirmData', this.tableFrom);
    },
    unique: function unique(arr) {
      return Array.from(new Set(arr));
    },
    importExcelData: function importExcelData(data) {
      var _this3 = this;
      if (data[0][0] == '示例：收入') {
        data.splice(0, 1);
      }
      var res = [];
      if (data.length <= 0) {
        this.$message.error('批量导出内容为空');
      } else {
        for (var i = 0; i <= data.length - 1; i++) {
          if (data[i][0] === '') {
            continue;
          } else {
            res.push({
              types: data[i][0],
              cate_id: data[i][1],
              num: data[i][2],
              pay_type: data[i][3],
              edit_time: this.$moment(data[i][4], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
              mark: data[i][5]
            });
          }
        }
        var data_s = {
          data: res
        };
        billImportApi(data_s).then(function (res) {
          _this3.tableFrom.search = 1;
          _this3.confirmData();
        }).catch(function (error) {});
      }
    }
  }, "exportTemplate", function exportTemplate() {
    this.gettime = this.$moment().format('YYYY-MM-DD HH:mm:ss');
    if (!this.exportFileUrl) {
      this.$message.error('暂无导入模板,请联系管理员');
    } else {
      this.fileLinkDownLoad(this.exportFileUrl, '收支记账导入模板' + this.gettime + '.xlsx');
    }
  }), "exportExcelData", function exportExcelData() {
    this.tableFrom.exportType = 1;
    this.confirmData();
  }), "getExportExcel", function getExportExcel() {
    this.$refs.exportExcel.exportExcel();
  }), "setDataDict", function setDataDict(field_name_en, data_dict) {
    for (var i = 0; i < this.search.length; i++) {
      if (this.search[i].field_name_en == field_name_en) {
        this.search[i].data_dict = data_dict;
        break;
      }
    }
  }), "treeChange", function treeChange(data) {
    this.handType(data.value);
  })
};